import React from 'react';
import { useNavigate } from 'react-router-dom';

const MENUS = [
  {
    id: 1,
    name: 'Authentic Palpali Bhoj Package',
    price: 'NPR 1,000 / guest',
    items: [
      'Palpali Chukauni (Spiced Yoghurt Potato)',
      'Batuk & Sel Roti (Traditional Bread)',
      'Local Mutton Curry / Local Chicken',
      'Steamed Basmati Rice & Dal Fry',
      'Mixed Pickle & Fresh Salad',
      'Gulab Jamun / Jalebi'
    ],
    tag: 'Palpali Specialty',
    emoji: '🍱',
    manager: 'Krishna Khanal (9867155395)'
  },
  {
    id: 2,
    name: 'Newari Samay Baji Feast',
    price: 'NPR 750 / guest',
    items: [
      'Samay Baji & Baji (Beaten Rice)',
      'Choila (Spiced Marinated Meat)',
      'Kachila & Wo (Bara Lentil Patties)',
      'Aalu Wala & Fried Bhatmas',
      'Bhaktapur Juju Dhau (King Curd)',
      'Traditional Beverages'
    ],
    tag: 'Newari Feast',
    emoji: '🍲',
    manager: 'Sabitri Master Chefs'
  },
  {
    id: 3,
    name: 'Grand Royal Banquet Multi-Cuisine Buffet',
    price: 'NPR 1,500 / guest',
    items: [
      'Paneer Butter Masala & Dal Makhani',
      'Butter Chicken / Fish Fry',
      'Veg Pulao & Naan Bread',
      'Live Pasta & Chaat Counter',
      'Ice Cream & Chocolate Fountain',
      'Soft Drinks & Mocktails'
    ],
    tag: 'Royal Banquet',
    emoji: '👑',
    manager: 'Krishna Khanal (9867155395)'
  }
];

export default function Menu() {
  const navigate = useNavigate();

  return (
    <div className="sec-wrapper">
      {/* Unified Vivah Nepal Hero Banner */}
      <section className="hero-section">
        <div className="hero-content">
          <div style={{ marginBottom: '1.2rem' }}>
            <span className="badge-hero-top">
              ✦ SABITRI CATERING FEAST MENUS ✦
            </span>
          </div>

          <h1 className="hero-title">
            Festive Nepalese Bhoj & <span className="hero-title-gradient">Royal Packages</span>
          </h1>

          <p className="hero-subtitle">
            Managed by <strong>Krishna Khanal</strong> (9867155395) & Partner <strong>Laxmikant Timilsina</strong> (Office: Yogikuti Chowk, Butwal-10). 5-Star certified hygiene.
          </p>

          <div className="hero-cta-group">
            <button className="btn btn-secondary" onClick={() => navigate('/catering/booking')}>
              Book Catering for Event →
            </button>
            <a href="tel:9867155395" className="btn btn-tertiary">
              📞 Call Krishna Khanal (9867155395)
            </a>
          </div>
        </div>
      </section>

      {/* Menu Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))',
        gap: '2rem',
        marginBottom: '3.5rem'
      }}>
        {MENUS.map((m) => (
          <div key={m.id} className="card pillar-card" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
                <div style={{ fontSize: '2.5rem' }}>{m.emoji}</div>
                <span className="badge-light">{m.tag}</span>
              </div>

              <h3 style={{ fontSize: '1.65rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.2rem', fontFamily: 'var(--serif)' }}>
                {m.name}
              </h3>
              <div style={{ fontSize: '1.4rem', fontWeight: 900, color: '#8C6A23', marginBottom: '0.4rem' }}>
                {m.price}
              </div>
              <div style={{ fontSize: '0.82rem', color: '#6E615E', fontWeight: 700, marginBottom: '1.2rem' }}>
                👨‍🍳 Prepared under supervision of {m.manager}
              </div>

              <ul style={{ listStyle: 'none', fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.8, marginBottom: '1.5rem' }}>
                {m.items.map((item, idx) => (
                  <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#9E1B32', fontWeight: 800 }}>✓</span> {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <button className="btn btn-primary btn-full" onClick={() => navigate('/catering/booking')}>
                Book Catering for Event →
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Custom Menu Request CTA */}
      <div className="card" style={{
        background: 'linear-gradient(135deg, #1C1014 0%, #28171C 100%)',
        color: 'white',
        border: '1.5px solid #D4AF37',
        textAlign: 'center'
      }}>
        <span className="badge" style={{ background: 'rgba(212, 175, 55, 0.25)', color: '#F7D070', marginBottom: '0.8rem' }}>
          👑 Custom Wedding Banquets
        </span>
        <h3 style={{ fontFamily: 'var(--serif)', fontSize: '2.1rem', fontWeight: 700, color: '#F7D070', margin: '0.4rem 0' }}>
          Want a Custom Menu for 500+ Guests?
        </h3>
        <p style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.85)', maxWidth: '650px', margin: '0 auto 1.5rem', lineHeight: 1.6 }}>
          Contact Sabitri Catering director <strong>Krishna Khanal (9867155395)</strong> or visit our main office at <strong>Butwal-10, Yogikuti Chowk</strong> for custom menu tasting.
        </p>
        <div style={{ display: 'flex', gap: '0.9rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button className="btn btn-secondary" onClick={() => navigate('/catering/booking')}>
            Request Custom Menu Booking →
          </button>
          <a href="tel:9867155395" className="btn btn-tertiary">
            📞 Call Krishna (9867155395)
          </a>
        </div>
      </div>
    </div>
  );
}